import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'

import { ROUTES } from './routePaths'
import ProtectedRoute from './ProtectedRoute'

import MainLayout    from '../layouts/MainLayout/MainLayout'
import SiteSelectPage  from '../pages/SiteSelect/SiteSelectPage'
import AuthPage        from '../pages/Auth/AuthPage'
import DashboardPage   from '../pages/Dashboard/DashboardPage'
import TicketsPage     from '../pages/Tickets/TicketsPage'
import SubmitTicketPage from '../pages/SubmitTicket/SubmitTicketPage'
import TicketDetailPage from '../pages/TicketDetail/TicketDetailPage'
import ProfilePage     from '../pages/Profile/ProfilePage'
import NotificationsPage from '../pages/Notifications/NotificationsPage'

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path={ROUTES.SITE_SELECT} element={<SiteSelectPage />} />
        <Route path={ROUTES.LOGIN}       element={<AuthPage />} />

        {/* Default redirect */}
        <Route path="*" element={<Navigate to={ROUTES.SITE_SELECT} replace />} />

        {/* Protected — wrapped in sidebar layout */}
        <Route
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route path={ROUTES.DASHBOARD}     element={<DashboardPage />} />
          <Route path={ROUTES.TICKETS}       element={<TicketsPage />} />
          <Route path={ROUTES.SUBMIT}        element={<SubmitTicketPage />} />
          <Route path={ROUTES.TICKET_DETAIL} element={<TicketDetailPage />} />
          <Route path={ROUTES.PROFILE}       element={<ProfilePage />} />
          <Route path={ROUTES.NOTIFICATIONS} element={<NotificationsPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
